import {ITraveller} from "@/model/Traveller"

export interface IHasTravellers {
    getTravellers(): ITraveller[]
    getTravellersMap(): Map<string, ITraveller>
    addTraveller(traveller: ITraveller): void
    removeTraveller(traveller: ITraveller): void
}

function hasTravellers<TBase extends Constructor>(Base: TBase) {
    
    class Bob extends Base implements IHasTravellers {
        private travellers: ITraveller[] = []
        private travellersMap: Map<string, ITraveller> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }
        
        public getTravellers(): ITraveller[] {
            return this.travellers
        }
        public getTravellersMap(): Map<string, ITraveller> {
            return this.travellersMap
        }
        public addTraveller(traveller: ITraveller): void {
            if (this.travellersMap.has(traveller.getId())) return
            this.travellers.push(traveller)
            this.travellersMap.set(traveller.getId(), traveller)
        }
        public removeTraveller(traveller: ITraveller): void {
            if (!this.travellersMap.has(traveller.getId())) return
            this.travellers = this.travellers.filter((_=>_.getId() !== traveller.getId()))
            this.travellersMap.delete(traveller.getId())
        }
    }
    return Bob
}

export default hasTravellers